/**
 * Benchmarks Instrument Configuration
 */

import ComparisonBenchmark from '@/types/comparison-benchmark';
import { ADVANCED_SEARCH_OPTIONS } from '@/utils/constants';
import { createInstrumentConfig } from '../utils';
import type { BenchmarkFilters, BenchmarkSearchParams } from '../types';

export const benchmarksInstrumentConfig = createInstrumentConfig<ComparisonBenchmark, BenchmarkFilters, BenchmarkSearchParams>({
  type: ADVANCED_SEARCH_OPTIONS.BENCHMARKS,
  endpoints: {
    filters: '/comparison-benchmarks/filters',
    search: '/comparison-benchmarks/search',
  },
});
